"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryTransformerUtil = void 0;
const StudioProjectAttributesV2Node_1 = require("../../project/domain/StudioProjectAttributesV2Node");
const JsonUtil_1 = require("../../cutil/JsonUtil");
const StudioProjectAttributesV3Node_1 = require("../../project/domain/StudioProjectAttributesV3Node");
const StudioProjectAttributesV3NodeData_1 = require("../../project/domain/StudioProjectAttributesV3NodeData");
const StoryNodeDisplayType_1 = require("../domain/StoryNodeDisplayType");
const ImageModel_1 = require("../model/ImageModel");
const StoryNodeState_1 = require("../domain/StoryNodeState");
const StockInfoModel_1 = require("../model/StockInfoModel");
const AskBrain_1 = require("../../api/askBrainTyped/AskBrain");
const Shopping_1 = require("../../api/shoppingTyped/Shopping");
const Grocery_1 = require("../../api/groceriesTyped/Grocery");
const ProteinModel_1 = require("../../storyV2/model/ProteinModel");
const SearchInfoWrapper_1 = require("../../storyV2/model/SearchInfoWrapper");
const Video_1 = require("../../api/videoTyped/Video");
const RestaurantModel_1 = require("../../storyV2/model/RestaurantModel");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const StoryUtil_1 = require("../../storyV2/domain/StoryUtil");
const AdapterUtil_1 = require("../../storyV2/adapter/AdapterUtil");
const AdapterRegistry_1 = require("../../storyV2/adapter/AdapterRegistry");
const MapModel_1 = require("../../storyV2/model/MapModel");
const UploadFileModel_1 = require("../model/UploadFileModel");
const BlueprintModel_1 = require("../model/BlueprintModel");
class StoryTransformerUtil {
    static createEmptyGroupUiData() {
        const dataModel = new StudioProjectAttributesV3NodeData_1.StudioProjectAttributesV3NodeData();
        dataModel.showWarning = false;
        dataModel.showStopGenerateBtn = false;
        dataModel.childNode = [];
        dataModel.abortNode = {};
        const model = new StudioProjectAttributesV3Node_1.StudioProjectAttributesV3Node();
        model.id = "";
        model.type = "";
        model.data = dataModel;
        const jsonStr = JsonUtil_1.JsonUtil.stringify(model) || "";
        const obj = JSON.parse(jsonStr);
        return obj;
    }
    static createEmptyNodeUiData() {
        const nodeIndexRef = new StudioProjectAttributesV2Node_1.StudioProjectAttributesV2NodeDataNodeIndexRef();
        nodeIndexRef.current = 0;
        const edgeIndexRef = new StudioProjectAttributesV2Node_1.StudioProjectAttributesV2NodeDataEdgeIndexRef();
        edgeIndexRef.current = 0;
        const dataModel = new StudioProjectAttributesV3NodeData_1.StudioProjectAttributesV3NodeData();
        dataModel.nodeIndexRef = nodeIndexRef;
        dataModel.edgeIndexRef = edgeIndexRef;
        dataModel.isResized = false;
        dataModel.share = null;
        dataModel.showWarning = false;
        dataModel.showStopGenerateBtn = false;
        dataModel.showFeedback = false;
        dataModel.textAreaValue = "";
        dataModel.displayType = "";
        dataModel.originId = "";
        dataModel.parentNode = "";
        dataModel.parentNodeId = "";
        dataModel.childNode = [];
        dataModel.chatBoxParam = [];
        dataModel.dropUploadFileData = {};
        dataModel.abortNode = {};
        dataModel.updateEdgeSourceContent = null;
        const model = new StudioProjectAttributesV3Node_1.StudioProjectAttributesV3Node();
        model.id = "";
        model.type = "";
        model.data = dataModel;
        const jsonStr = JsonUtil_1.JsonUtil.stringify(model) || "";
        const obj = JSON.parse(jsonStr);
        return obj;
    }
    static fromLoadingImgEdge(storyNode, story) {
        let edge = StoryUtil_1.StoryUtil.findNodeSource(story, storyNode);
        if (storyNode.options.parentId) {
            const groupNode = story.findNodesById(storyNode.options.parentId);
            if (groupNode) {
                edge = StoryUtil_1.StoryUtil.findNodeSource(story, groupNode);
            }
        }
        const edgeName = edge?.options.actionData.enterText || "";
        if (edge &&
            storyNode.state === StoryNodeState_1.StoryNodeState.LOADING &&
            AdapterUtil_1.AdapterUtil.isFuncEdge(edgeName) &&
            AdapterUtil_1.AdapterUtil.outputMaybeImage(edgeName)) {
            return true;
        }
        return false;
    }
    // 判断edge 是否是输出 audio
    static fromAudioEdge(storyNode, story) {
        let edge = StoryUtil_1.StoryUtil.findNodeSource(story, storyNode);
        if (storyNode.options.parentId) {
            const groupNode = story.findNodesById(storyNode.options.parentId);
            if (groupNode) {
                edge = StoryUtil_1.StoryUtil.findNodeSource(story, groupNode);
            }
        }
        const edgeName = edge?.options.actionData.enterText || "";
        if (edge &&
            storyNode.state === StoryNodeState_1.StoryNodeState.LOADING &&
            AdapterUtil_1.AdapterUtil.isFuncEdge(edgeName) &&
            AdapterUtil_1.AdapterUtil.ouputMaybeAudio(edgeName)) {
            return true;
        }
        return false;
    }
    static fromImgSearchEdge(storyNode, story) {
        const edge = StoryUtil_1.StoryUtil.findNodeSource(story, storyNode);
        const edgeName = edge?.options.actionData.enterText || "";
        if (edge && edgeName == AdapterRegistry_1.AdapterName.imageSearch) {
            return true;
        }
        return false;
    }
    static createDisplayType(storyNode, story) {
        let returnType = storyNode.options.displayType;
        /// 如果边是一条loading状态的img类型的边，node应该即刻转成img类型
        if (StoryTransformerUtil.fromLoadingImgEdge(storyNode, story)) {
            if (StoryTransformerUtil.fromImgSearchEdge(storyNode, story)) {
                returnType = StoryNodeDisplayType_1.StoryNodeDisplayType.IMAGESEARCH;
            }
            else {
                returnType = StoryNodeDisplayType_1.StoryNodeDisplayType.IMAGEGEN;
            }
        }
        else if (StoryTransformerUtil.fromAudioEdge(storyNode, story)) {
            returnType = StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO;
        }
        return returnType;
    }
    static createTextAreaValue(storyNode, story, displayType) {
        switch (displayType) {
            case StoryNodeDisplayType_1.StoryNodeDisplayType.IMAGEGEN:
                return StoryTransformerUtil.createTextAreaValueImg(storyNode, displayType, story);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.IMAGESEARCH:
                return StoryTransformerUtil.createTextAreaValueImg(storyNode, displayType, story);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.STOCKINFO:
                return StoryTransformerUtil.createTextAreaValueStock(storyNode);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.ASKBRAIN:
                return StoryTransformerUtil.createTextAreaValueAskBrain(storyNode);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.AMAZONSHOPPING:
                return StoryTransformerUtil.createTextAreaValueAmazon(storyNode);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.JDSHOPPING:
                return StoryTransformerUtil.createTextAreaValueJDShopping(storyNode);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.WEEEGROCERIES:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.WEEESHOPPING:
                return StoryTransformerUtil.createTextAreaValueWeee(storyNode);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.CUSTOMJSFUNCTION:
                return StoryTransformerUtil.createTextAreaValueProtein(storyNode) || storyNode.content;
            case StoryNodeDisplayType_1.StoryNodeDisplayType.VIDEO:
                return StoryTransformerUtil.createTextAreaValueYoutube(storyNode);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.SHOWFOODINTERFACE:
                return StoryTransformerUtil.createTextAreaValueFood(storyNode);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.MIDJOURNEY:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.MIDJOURNEYV2:
                return StoryTransformerUtil.createTextAreaValueMidjourney(storyNode);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.CHATINTERFACE:
                return StoryTransformerUtil.createTextAreaValueChatInterface(storyNode);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.INTERVIEW_BOT:
                return StoryTransformerUtil.createTextAreaValueInterviewBot(storyNode);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.MAP:
                return StoryTransformerUtil.createTextAreaValueMap(storyNode);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.BASEVIDEO:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.TABLE:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.PDFFILE:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADIMAGE:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.HTML:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADFILE:
                return StoryTransformerUtil.createTextAreaValueUploadFile(storyNode);
            case StoryNodeDisplayType_1.StoryNodeDisplayType.TEXT:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.JSON:
            case StoryNodeDisplayType_1.StoryNodeDisplayType.CUSTOMAPIFUNCTION:
                return storyNode.content;
            case StoryNodeDisplayType_1.StoryNodeDisplayType.BLUEPRINT:
                return StoryTransformerUtil.createTextAreaValueBluePoint(storyNode);
        }
        /// todo:
        return storyNode.content;
    }
    static createTextAreaValueBluePoint(storyNode) {
        const storyBlueprintModel = storyNode.parseContent(BlueprintModel_1.BlueprintModel);
        const bluePrintModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3BluePrintValue();
        bluePrintModel.data = storyBlueprintModel?.data;
        bluePrintModel.message = storyBlueprintModel?.message;
        return bluePrintModel;
    }
    static createTextAreaValueProtein(storyNode) {
        const storyProteinModel = storyNode.parseContent(ProteinModel_1.ProteinModel);
        const projectProteinModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3ProteinValue();
        projectProteinModel.loading =
            storyNode.state === StoryNodeState_1.StoryNodeState.LOADING || storyNode.state === StoryNodeState_1.StoryNodeState.RECEIVING;
        if (storyProteinModel == undefined || storyProteinModel.value === "") {
            projectProteinModel.value = storyNode.content;
            projectProteinModel.type = "";
        }
        else {
            projectProteinModel.value = storyProteinModel.value;
            projectProteinModel.type = storyProteinModel.type;
        }
        return projectProteinModel;
    }
    static createTextAreaValueImg(storyNode, displayType, story) {
        const storyImgModel = storyNode.parseContent(ImageModel_1.ImageModel);
        const projectImgModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3ImageValue();
        const v3Data = storyNode.parseContent(StudioProjectAttributesV3NodeData_1.StudioProjectV3ImageValue) || projectImgModel;
        if (v3Data.fromUIData) {
            if (StoryTransformerUtil.fromLoadingImgEdge(storyNode, story)) {
                projectImgModel.loading = true;
                return projectImgModel;
            }
            return v3Data;
        }
        if (storyNode.state == StoryNodeState_1.StoryNodeState.LOADING || storyNode.state == StoryNodeState_1.StoryNodeState.RECEIVING) {
            projectImgModel.loading = true;
        }
        else {
            projectImgModel.loading = false;
            projectImgModel.value = storyImgModel?.value ?? "";
            if (displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.IMAGEGEN) {
                projectImgModel.context = storyImgModel?.content;
            }
        }
        return projectImgModel;
    }
    static createTextAreaValueStock(storyNode) {
        const storyStockModel = storyNode.parseContent(StockInfoModel_1.StockInfoModel);
        const projectStockModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3StockValue();
        projectStockModel.logo = storyStockModel?.logo;
        projectStockModel.name = storyStockModel?.name;
        projectStockModel.symbol = storyStockModel?.symbol;
        projectStockModel.price = storyStockModel?.price;
        projectStockModel.volume = storyStockModel?.volume;
        return projectStockModel;
    }
    static createTextAreaValueChatInterface(storyNode) {
        const data = JsonUtil_1.JsonUtil.parse(storyNode.content);
        const projectChatInterfaceModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3ChatInterfaceValue();
        projectChatInterfaceModel.file = data?.file;
        projectChatInterfaceModel.filename = data?.filename;
        projectChatInterfaceModel.date = data?.date;
        projectChatInterfaceModel.pubsub_topic = data?.pubsub_topic;
        projectChatInterfaceModel.json = data?.json;
        projectChatInterfaceModel.text = data?.text;
        projectChatInterfaceModel.file_uuid = data?.uuid;
        return projectChatInterfaceModel;
    }
    static createTextAreaValueInterviewBot(storyNode) {
        const projectInterviewBotModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3InterviewBotValue();
        projectInterviewBotModel.msg = storyNode.content;
        projectInterviewBotModel.loading = storyNode.state === StoryNodeState_1.StoryNodeState.COMPLETED ? false : true;
        return projectInterviewBotModel;
    }
    static createTextAreaValueAskBrain(storyNode) {
        const storyAskBrainModel = storyNode.parseContent(AskBrain_1.AskBrainData);
        const projectAskBrainModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3AskBrainValue();
        projectAskBrainModel.query = storyAskBrainModel?.query;
        projectAskBrainModel.answer = storyAskBrainModel?.answer;
        projectAskBrainModel.latency = storyAskBrainModel?.latency;
        if (storyAskBrainModel?.sources_data) {
            projectAskBrainModel.sources_data = Object.entries(storyAskBrainModel?.sources_data ?? {}).map(
            // eslint-disable-next-line
            ([key, value]) => value);
        }
        return projectAskBrainModel;
    }
    static createTextAreaValueAmazon(storyNode) {
        const items = storyNode.parseSearchData(Shopping_1.ShoppingItem);
        const query = storyNode.parseSearchKey();
        const projectAmazonModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3ShoppingValue();
        const v3Data = storyNode.parseContent(StudioProjectAttributesV3NodeData_1.StudioProjectV3ShoppingValue) || projectAmazonModel;
        if (v3Data.fromUIData) {
            return v3Data;
        }
        projectAmazonModel["querys"] = [query];
        projectAmazonModel["loading"] = storyNode.state === StoryNodeState_1.StoryNodeState.COMPLETED ? false : true;
        projectAmazonModel[query] = { items: items };
        return projectAmazonModel;
    }
    static createTextAreaValueMap(storyNode) {
        const mapModel = storyNode.parseContent(MapModel_1.MapModel);
        const projectMapModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3MapValue();
        const v3Data = storyNode.parseContent(StudioProjectAttributesV3NodeData_1.StudioProjectV3MapValue) || projectMapModel;
        if (v3Data.fromUIData) {
            return v3Data;
        }
        projectMapModel.value = mapModel?.value;
        projectMapModel.date = mapModel?.date;
        return projectMapModel;
    }
    static createTextAreaValueUploadFile(storyNode) {
        const uploadFileModel = storyNode.parseContent(UploadFileModel_1.UploadFileModel);
        const projectUploadFileModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3UploadFileValue();
        const v3Data = storyNode.parseContent(StudioProjectAttributesV3NodeData_1.StudioProjectV3UploadFileValue) || projectUploadFileModel;
        if (v3Data.fromUIData) {
            return v3Data;
        }
        projectUploadFileModel.format = uploadFileModel?.format;
        projectUploadFileModel.name = uploadFileModel?.name;
        projectUploadFileModel.needToCreateBlobUrl = uploadFileModel?.needToCreateBlobUrl;
        projectUploadFileModel.s3Path = uploadFileModel?.s3Path;
        projectUploadFileModel.s3Url = uploadFileModel?.s3Url;
        projectUploadFileModel.uuid = uploadFileModel?.uuid;
        return projectUploadFileModel;
    }
    static createTextAreaValueJDShopping(storyNode) {
        const items = storyNode.parseSearchData(Shopping_1.ShoppingItem);
        const info = storyNode.parseContent((SearchInfoWrapper_1.SearchInfoWrapper));
        const projectShoppingModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3ShoppingValue();
        const v3Data = storyNode.parseContent(StudioProjectAttributesV3NodeData_1.StudioProjectV3ShoppingValue) || projectShoppingModel;
        if (v3Data.fromUIData) {
            return v3Data;
        }
        projectShoppingModel["source"] = info?.source;
        projectShoppingModel["items"] = items;
        projectShoppingModel["loading"] = false;
        projectShoppingModel["page"] = { currIndex: info?.pagination.page, totalPage: info?.pagination.totalPage };
        return projectShoppingModel;
    }
    static createTextAreaValueWeee(storyNode) {
        const items = storyNode.parseSearchData(Grocery_1.WeeeItem);
        const info = storyNode.parseContent((SearchInfoWrapper_1.SearchInfoWrapper));
        const projectShoppingModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3ShoppingValue();
        const v3Data = storyNode.parseContent(StudioProjectAttributesV3NodeData_1.StudioProjectV3ShoppingValue) || projectShoppingModel;
        if (v3Data.fromUIData) {
            return v3Data;
        }
        projectShoppingModel["source"] = info?.source;
        projectShoppingModel["items"] = items;
        projectShoppingModel["loading"] = false;
        projectShoppingModel["pagination"] = info?.pagination;
        return projectShoppingModel;
    }
    static createTextAreaValueCustomApi(storyNode) {
        const projectCustomApiModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3CustomApiValue();
        projectCustomApiModel.data = {
            type: "json",
            value: JSON.parse(storyNode.content),
        };
        return projectCustomApiModel;
    }
    static createTextAreaValueYoutube(storyNode) {
        const storyYoutubeModel = storyNode.parseContent((SearchInfoWrapper_1.SearchInfoWrapper));
        const projectYoutubeModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3YoutubeValue();
        const v3Data = storyNode.parseContent(StudioProjectAttributesV3NodeData_1.StudioProjectV3YoutubeValue) || projectYoutubeModel;
        if (v3Data.fromUIData) {
            return v3Data;
        }
        projectYoutubeModel.items = storyNode.parseSearchData(Video_1.VideoItem);
        projectYoutubeModel.query = storyNode.parseSearchKey();
        projectYoutubeModel.key = storyYoutubeModel?.pagination.youtube?.key;
        projectYoutubeModel.continuation = storyYoutubeModel?.pagination.youtube?.continuation;
        projectYoutubeModel.context = storyYoutubeModel?.pagination.youtube?.context;
        return projectYoutubeModel;
    }
    static createTextAreaValueFood(storyNode) {
        const storyFoodModel = storyNode.parseContent((SearchInfoWrapper_1.SearchInfoWrapper));
        const projectFoodModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3FoodValue();
        const v3FoodValue = storyNode.parseContent(StudioProjectAttributesV3NodeData_1.StudioProjectV3FoodValue) || projectFoodModel;
        if (v3FoodValue.fromUIData) {
            return v3FoodValue;
        }
        projectFoodModel.query = storyFoodModel?.searchKey;
        projectFoodModel.next = storyFoodModel?.pagination.next;
        projectFoodModel.stores = (storyNode.parseSearchData(RestaurantModel_1.RestaurantModel) ?? []).map(x => x.value);
        return projectFoodModel;
    }
    static createTextAreaValueMidjourney(storyNode) {
        const projectMidjourneyModel = new StudioProjectAttributesV3NodeData_1.StudioProjectV3MidjourneyValue();
        if ((0, is_blank_1.default)(storyNode.content)) {
            return projectMidjourneyModel;
        }
        const data = JSON.parse(storyNode.content);
        projectMidjourneyModel.loading = data.loading;
        projectMidjourneyModel.value = data.value;
        projectMidjourneyModel.messageId = data.messageId;
        projectMidjourneyModel.meId = data.meId;
        projectMidjourneyModel.progress = data.progress;
        projectMidjourneyModel.polling = data.progress;
        projectMidjourneyModel.value = data.value;
        return projectMidjourneyModel;
    }
}
exports.StoryTransformerUtil = StoryTransformerUtil;
